// Formatters (currenty just currency formatter)

export default class Formatter {

   static FormatCurrency(int) {
      var formatParams = new Intl.NumberFormat('en-AU', {
         style: 'currency',
         currency: 'AUD',
         minimumFractionDigits: 0,
         maximumFractionDigits: 2
      });
      return formatParams.format(int)
   }

}
